import Home from './views/Home.sources'
import AdvId from './views/AdvId.sources'

export default {
  Home, AdvId
}
